import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import Commons from '../../Services/Common/Common';
function ST10050(props) {
    React.useEffect(() => {
        document.title = '재고이력';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '재고관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>재고이력</strong>" +
            '</h1>';
    }, []);

    const gridRef = React.useRef();
    const autoGroupColumnDef = React.useMemo(() => {
        //그룹설정
        return {
            headerName: '수불타입',
            minWidth: 330,
        };
    }, []);
    const rowGroupPanelShow = 'always';
    const groupDefaultExpanded = 1;
    const columnDefs = [
        //수불타입
        {
            field: 'tranType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PayType' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 70,
            rowGroup: true,
            enableRowGroup: true,
            hide: true,
        },

        //수불일자
        {
            field: 'tranDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PayDt' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
            enableRowGroup: true,
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 300,
            enableRowGroup: true,
            // rowGroup: true,
            // hide: true,
        },

        //창고명
        {
            field: 'whNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_WhNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            suppressMovable: true,
            valueFormatter: (params) => {
                var formatted = params.value
                    ? params.value.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
                    : '';
                return formatted;
            },
            cellStyle: { textAlign: 'right' },
            cellRenderer: Commons.CustomWhCdRenderer,
        },
        //수불수량
        {
            field: 'tranQty',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PayQty' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 110,
            suppressMovable: true,
            aggFunc: 'sum',
            cellStyle: { textAlign: 'right' },
            cellRenderer: Commons.CustomNumberRenderer,
        },
        //LotNo
        {
            field: 'lotNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LotNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //참고문서번호(수불번호)
        {
            field: 'refDocNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ReferenceNm' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //수불번호
        {
            field: 'tranNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PayNo' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //등록자
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
        //등록일
        {
            field: 'createDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '',
            minWidth: 100,
        },
    ];
    return (
        <div>
            <Section />
            <Card
                wrapStyle={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{ width: '120px', marginRight: '5px' }}
                        selected={props.startDate}
                        onChange={(e) => {
                            props.setStartDate(e);
                        }}
                    />
                    ~
                    <DatePicker
                        className={'datepicker-custom-input'}
                        style={{ width: '120px', marginLeft: '5px' }}
                        selected={props.endDate}
                        onChange={(e) => {
                            props.setEndDate(e);
                        }}
                    />
                </div>
                <AuthGroupButton
                    pageName="MM10080"
                    target="G01"
                    refreshNone="none"
                    selectFunc={() => {
                        props.Init();
                    }}
                />
            </Card>
            <Section />
            <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                <AgGridReact
                    ref={gridRef}
                    animateRows={true}
                    columnDefs={columnDefs}
                    // groupDefaultExpanded={groupDefaultExpanded}
                    rowGroupPanelShow={rowGroupPanelShow}
                    // groupIncludeTotalFooter={true}
                    autoGroupColumnDef={autoGroupColumnDef}
                    suppressAggFuncInHeader={true} //헤더컬럼에 sum제거
                    // autoSizeAll={autoSizeAll()}
                    defaultColDef={{
                        flex: 1,
                        editable: false,
                        resizable: true,
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                    }}
                    cellDataType={false}
                    onCellValueChanged={(e) => GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)}
                    rowData={props.rowData}
                    rowSelection="single"
                    onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                    getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : '')}
                />
            </div>
        </div>
    );
}

export default ST10050;
